"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InferenceReportUtil = void 0;
class InferenceReportUtil {
    static getParameterValue(report, parameterName) {
        return report.parameters?.[parameterName];
    }
    static getParameterValueVarianceMap(report) {
        return Object.fromEntries(Object.entries(report.parameters ?? {}).map(([key, value]) => [
            key,
            typeof value === 'object' ? value?.value : { value: value },
        ]));
    }
    static setParameterValue(report, parameterName, value) {
        if (!report.parameters) {
            report.parameters = {};
        }
        report.parameters[parameterName] = value;
    }
    static getHighestPrioritySignalEntry(report, signalId) {
        return report.signals?.find((e) => e.signalId === signalId);
    }
    static getEntriesForSignal(report, signalId) {
        return report.signals?.filter((e) => e.signalId === signalId) ?? [];
    }
    static setSignalEntry(report, entry, replaceExistingFromSameSource = true) {
        if (!report.signals) {
            report.signals = [];
        }
        else if (replaceExistingFromSameSource) {
            report.signals = report.signals.filter((e) => e.signalId !== entry.signalId || e.source !== entry.source);
        }
        report.signals.push(entry);
        return report;
    }
}
exports.InferenceReportUtil = InferenceReportUtil;
//# sourceMappingURL=InferenceReportUtil.js.map